<footer class="footer">
  <div class="footer__logos row-1140">
    <div class="footer__logo">
      <img src="assets/images/logo-white.svg" alt="PinPag" />
    </div>

    <div class="footer__seal">
      <div id="ra-verified-seal" #seal></div>
    </div>

    <div class="footer__socials">
      <a href="https://www.facebook.com/PinPag" target="_blank" rel="noopener" aria-label="Facebook">
        <i class="icon icon--facebook"></i>
      </a>
      <a href="https://www.instagram.com/pinpagoficial/" target="_blank" rel="noopener" aria-label="Instagram">
        <i class="icon icon--instagram"></i>
      </a>
      <a
        href="https://www.youtube.com/channel/UCUXcRt9mol2p0O37IAutrKg"
        target="_blank"
        rel="noopener"
        aria-label="YouTube"
      >
        <i class="icon icon--youtube"></i>
      </a>
    </div>
  </div>

  <div class="footer__infos row-1140">
    <div class="footer__col">
      <h5>Sobre</h5>
      <ul>
        <li><a routerLink="/quem-somos">Quem somos</a></li>
        <li><a routerLink="/faq">Dúvidas frequentes</a></li>
        <li><a routerLink="/suporte">Suporte</a></li>
        <li>
          <button type="button" class="footer__link" (click)="openPrivacyPolicy()">
            Política de Privacidade
          </button>
        </li>
        <li>
          <button type="button" class="footer__link" (click)="openOmbudsman()">Ouvidoria</button>
        </li>
      </ul>
    </div>

    <div class="footer__col footer__col--wide">
      <h5>Para o seu negócio</h5>
      <ul>
        <li><a routerLink="/maquininhas">Maquininhas</a></li>
        <li>
          <span>Segmentos</span>
          <ul class="footer__submenu">
            <li><a routerLink="/despachantes-documentalistas">Despachantes</a></li>
            <li><a routerLink="/cartorios">Cartórios</a></li>
            <li><a routerLink="/educacao">Área da Educação</a></li>
            <li><a routerLink="/saude">Área da Saúde</a></li>
            <li><a routerLink="/oficina-mecanica">Oficinas Mecânicas</a></li>
            <li><a routerLink="/concessionarias">Concessionárias</a></li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="footer__col footer__col--wide">
      <h5>Nossos Serviços</h5>
      <ul>
        <li><a routerLink="/bom-condutor">Bom Condutor</a></li>
        <li>
          <a href="https://www.webdespachantes.com.br/" target="_blank" rel="noopener">WebDespachantes</a>
        </li>
        <li><a routerLink="/pdv">Pontos de atendimento</a></li>
        <li><a routerLink="/link-de-pagamento">Link de Pagamento</a></li>
        <li><a routerLink="/checkout-online">Checkout Online</a></li>
        <li>
          <a href="https://www.webdespachantes.com.br/" target="_blank" rel="noopener">
            Parcelamento de débitos veiculares
          </a>
        </li>
      </ul>
      <h5>Nossos Produtos</h5>
      <ul>
        <li><a routerLink="/maquininhas">Maquinas de Pagamento</a></li>
      </ul>
    </div>

    <div class="footer__col footer__col--wide">
      <h5>Serviços</h5>
      <ul>
        <li><a href="https://www.quantovendi.com.br/" target="_blank" rel="noopener">Quanto Vendi</a></li>
        <li><a href="https://manager.pinpag.com.br/" target="_blank" rel="noopener">Despachantes e CFC</a></li>
        <li>
          <a href="https://manager.pinpag.com.br/" target="_blank" rel="noopener">Loja de veículos / Simulador</a>
        </li>
        <li><a href="https://manager.pinpag.com.br/" target="_blank" rel="noopener">Cartórios</a></li>
      </ul>
    </div>

    <div class="footer__col">
      <h5>Contato</h5>
      <address>
        São Paulo e Grande São Paulo<br />
        <a [href]="whatsappUrl" target="_blank" rel="noopener">(11) 4223-7590</a><br />
        Demais localidades<br />
        <a href="tel:08005775777">0800-577-5777</a>
        <a [href]="whatsappUrl" target="_blank" rel="noopener">(11) 4223-7590</a><br />
        <a href="mailto:sac@pinpag.com.br">sac&#64;pinpag.com.br</a>
      </address>
    </div>
  </div>

  <div class="footer__copyright">
    <p>
      Pinpag Instituição de Pagamentos SA, inscrita no CNPJ no 17.768.068/0001-18, localizada na Rua
      Niterói, nº 400, conjunto nº 1003, Centro, São Caetano do Sul . SP, CEP: 09.510-200. A PinPag
      não é uma instituição financeira, somos um correspondente bancário, nos termos da Resolução nº
      3.954, de 24 de fevereiro de 2011.
    </p>
    <hr />
    <p>Copyright © PinPag. Todos os direitos reservados.</p>
  </div>
</footer>
